import { animate, state, style, transition, trigger } from '@angular/animations';

export const expandCollapse = (duration: number) =>
  trigger('expandCollapse', [
    state(
      'false',
      style({
        'height': '0px',
        'padding-top': '0px',
        'padding-bottom': '0px',
        'overflow': 'hidden',
      })
    ),
    state(
      'void',
      style({
        'height': '0px',
        'padding-top': '0px',
        'padding-bottom': '0px',
        'overflow': 'hidden',
      })
    ),
    transition('false => true, :enter', [
      animate(
        `${duration}ms ease-in-out`,
        style({
          'height': '*',
          'padding-top': '*',
          'padding-bottom': '*',
        })
      ),
    ]),
    transition('true => false, :leave', animate(`${duration}ms ease-in-out`)),
  ]);

export const slideInOut = () =>
  trigger('slideInOut', [
    state(
      'in',
      style({
        transform: 'translateX(0)',
        right: '0px',
      })
    ),
    state(
      'in-rtl',
      style({
        transform: 'translateX(0)',
        left: '0px',
      })
    ),
    state(
      'out',
      style({
        transform: 'translateX(100%)',
        right: '0px',
      })
    ),
    state(
      'out-rtl',
      style({
        transform: 'translateX(-100%)',
        left: '0px',
      })
    ),
    transition('in => out', animate('400ms ease-in-out')),
    transition('out => in', animate('400ms ease-in-out')),
    transition('in-rtl => out-rtl', animate('400ms ease-in-out')),
    transition('out-rtl => in-rtl', animate('400ms ease-in-out')),
  ]);
